import { Box, Grid } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { memo, useCallback, useEffect, useRef, useState } from 'react';
import { usePrevious } from 'react-use';

import { activeContactIdQueryParam, searchValueQueryParam } from '../../constants';
import { Filter } from './components/Filter/Filter';
import { Item } from './components/Item/Item';
import { ContactListLoading } from './ContactList.loading';
import { ContactListProps } from './ContactList.types';

export const ContactList = memo<ContactListProps>((props) => {
    const { data, isFetching, isFetchingNextPage, fetchNextPage } = props;

    const listRef = useRef<HTMLDivElement>(null);

    const [activeContactId] = hooks.useQueryParam(activeContactIdQueryParam);

    const [searchValue] = hooks.useQueryParam(searchValueQueryParam);

    const prevSearchValue = usePrevious(searchValue);

    const [isSearchChanged, setIsSearchChanged] = useState(false);

    useEffect(() => {
        setIsSearchChanged((current) => {
            return current ? true : prevSearchValue !== searchValue;
        });
    }, [searchValue, prevSearchValue]);

    const loadMoreRequests = useCallback(() => {
        if (!isFetchingNextPage) {
            fetchNextPage();
        }
    }, [fetchNextPage, isFetchingNextPage]);

    const triggerRef = hooks.useLoadMoreOnObserve(listRef, loadMoreRequests);

    const isFirstLoad = isFetching && !isSearchChanged;

    const showLoading = isFirstLoad || isFetchingNextPage;

    return (
        <Grid height='100%' overflowY='hidden' gridTemplateRows='max-content auto'>
            <Filter />

            <Box ref={listRef} overflowY='auto' role='list'>
                {data?.pages.map((page) => {
                    return page.items.map((counterparty) => (
                        <Item
                            key={counterparty.counterpartyId}
                            contactId={counterparty.counterpartyId}
                            contactName={counterparty.name}
                            billingAddress={counterparty.billingAddress}
                            active={activeContactId === counterparty.counterpartyId}
                            hasDetails={counterparty.paymentDetails.length > 0}
                        />
                    ));
                })}

                {showLoading ? <ContactListLoading /> : <div ref={triggerRef} />}
            </Box>
        </Grid>
    );
});

ContactList.displayName = 'ContactList';
